<template>
  <div class="translationReport">
    <div>
      <span v-for="(word, _index) in sentList" :key="_index">
        <el-popover v-if="word.errorPosInfo" popper-class="translationReport_popover" placement="top-start"
          trigger="hover" width="400">
          <div>
            <span>{{ word.errorPosInfo.originalSegment }} → {{ word.errorPosInfo.correction }}</span>
            <p>【{{ word.errorPosInfo.errorType }}】{{ word.errorPosInfo.explanation }}</p>
          </div>
          <span slot="reference" style="color: #fb6863; text-decoration: underline; white-space: pre-wrap">{{
            word.rawSent }}</span>
        </el-popover>
        <span v-else>{{ word.rawSent }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'translationReport',
  props: {
    result: {
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      sentList: [],
      correctedText: '',
    }
  },
  methods: {
    init() {
      let sentList = []
      let originText = this.result.originText || ''
      const detailedErrors = this.result.detailedErrors || []
      if (!originText || !detailedErrors.length) {
        this.sentList = [{
          rawSent: originText,
        }]
        return
      }

      let last = 0
      detailedErrors.forEach((item) => {
        const originalSegment = item.originalSegment || ''
        if (!originalSegment) return

        const searchFrom = Math.max(last, 0)
        const idx = originText.indexOf(originalSegment, searchFrom)
        if (idx === -1) return

        if (idx > last) {
          sentList.push({
            rawSent: originText.slice(last, idx),
          })
        }

        sentList.push({
          rawSent: originalSegment,
          errorPosInfo: item,
        })

        last = idx + originalSegment.length
      })

      if (last < originText.length) {
        sentList.push({
          rawSent: originText.slice(last, originText.length),
        })
      }

      this.sentList = sentList
    },
  },
  watch: {
    result(v) {
      if (v && v.detailedErrors) {
        this.init()
      }
    },
  },
  mounted() {
  },
  destroyed() { },
}
</script>

<style lang="less">
.translationReport_popover {
  display: inline;
  background: #24cc7c !important;

  * {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/TranslationReport/main.vue